<template>
    <vx-box
        :class="{
            'rounded-[16px] border border-solid border-slate-300 bg-slate-200': !open,
        }"
        :color="open ? 'info' : 'white'"
        class="py-4 lg:py-6"
    >
        <div class="flex items-center justify-between text-slate-800 px-4 lg:pl-9 lg:pr-6">
            <div class="flex items-center gap-4">
                <font-awesome-icon widthAuto :icon="faBarsFilter" class="text-base ml-2" />

                <span class="font-extrabold lg:text-xl">Filters</span>
                <vx-badge color="primary" size="xs" data-test="filters-count">
                    {{ matchesCount }}
                </vx-badge>
            </div>

            <div>
                <vx-button @click="open = !open" class="w-12 px-4 ml-4" color="muted-dark" size="md" type="button">
                    <font-awesome-icon widthAuto :icon="open ? faCaretUp : faCaretDown"></font-awesome-icon>
                </vx-button>
            </div>
        </div>

        <animate-height :height="open ? 'auto' : 0">
            <div class="mt-4">
                <automation-rule-form-match-group
                    v-for="(matchGroup, matchGroupIndex) in data.match_groups"
                    :key="matchGroup.id"
                    :matchGroupIndex="matchGroupIndex"
                    :isLast="matchGroupIndex + 1 == data.match_groups.length"
                >
                </automation-rule-form-match-group>
                <div v-if="props.error" class="relative px-7 pt-4 text-xs text-rose-800">
                    {{ props.error }}
                </div>
            </div>
        </animate-height>
    </vx-box>
</template>

<script setup>
import { computed, ref } from 'vue';
import { faBarsFilter, faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox, VxButton, VxBadge } from '@voxie/frontend-components';
import AnimateHeight from 'vue-animate-height';
import { useAutomationRule } from './useAutomationRule';
import AutomationRuleFormMatchGroup from './AutomationRuleFormMatchGroup.vue';

const props = defineProps({
    error: String,
});

const { data } = useAutomationRule();
const open = ref(true);

const matchesCount = computed(() => {
    return (data.value.match_groups || []).reduce((acc, matchGroup) => {
        return acc + matchGroup.matches.length;
    }, 0);
});
</script>
